import { memo } from "react";
import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

function IconAdd(props: SvgIconProps) {
  return (
    <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9 5V13" stroke="currentColor" />
      <path d="M5 9L13 9" stroke="currentColor" />
    </SVGIcon>
  );
}

export default memo(IconAdd);
